import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetBlogByIdQuery, useGetBlogsQuery } from '../../redux/Apis/Blog';
import { Box, Typography, Container, Grid, Card, CardContent, CardMedia } from '@mui/material';

const BlogComponent = () => {
    // Change from id to slug in useParams
    const { slug } = useParams();
    
    const { 
        data: response, 
        isLoading, 
        isError,
        refetch 
    } = useGetBlogByIdQuery(slug, {
        refetchOnMountOrArgChange: true,
        skip: !slug
    });

    useEffect(() => {
        if (slug) {
            refetch();
        }
    }, [refetch, slug]);

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error loading blog</div>;

    // If no slug is provided, show blog listing
    if (!slug) {
        return (
            <Container maxWidth="lg">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h2" component="h1" gutterBottom>
                        Blogs
                    </Typography>
                    <Grid container spacing={3}>
                        {response?.data?.map((blog) => (
                            <Grid item xs={12} sm={6} md={4} key={blog._id}>
                                <Card>
                                    {blog.image && (
                                        <CardMedia
                                            component="img"
                                            height="200"
                                            image={`${process.env.REACT_APP_IMAGE_BASE_URL}/${blog.image}`}
                                            alt={blog.title}
                                        />
                                    )}
                                    <CardContent>
                                        <Typography variant="h5" component="h2">
                                            {blog.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {blog.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        );
    }

    // Show single blog post
    const blog = response?.data;
    if (!blog) return <div>Blog not found</div>;

    return (
        <Container maxWidth="md" sx={{ p: 0 }}>
            <Box sx={{ my: 10 }}>
                <Card sx={{ backgroundColor: "transparent", p: { xs: 1, md: 5 } }}>
                    <Typography
                        variant="h3"
                        sx={{
                            mb: 5,
                            color: "black",
                            fontSize: { xs: "1.75rem", sm: "2.25rem" },
                        }}
                    >
                        {blog.title}
                    </Typography>
                    {blog.image && (
                        <CardMedia
                            component="img"
                            image={`${process.env.REACT_APP_IMAGE_BASE_URL}${blog.image}`}
                            alt={blog.title}
                            sx={{
                                height: { xs: 150, md: 400 },
                                mb: 5,
                                objectFit: 'contain'
                            }}
                        />
                    )}
                    <CardContent>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            {blog.description}
                        </Typography>
                        <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default BlogComponent;
